module.exports = __webpack_public_path__ + "media/flags/as-cf35c447.svg";